import { createSlice } from '@reduxjs/toolkit';
import { readToken } from 'Utils/Helpers/Token';

const userSlice = createSlice({
    name: 'user',
    initialState : {
        isLogin: readToken() !== undefined,
    },
    reducers : {
        changeToLogin: (state) => {
            state.isLogin = true;
        },
        changeToLogout: (state) => {
            state.isLogin = false;
        },
    }
})

export const { 
    changeToLogin,
    changeToLogout,
 } = userSlice.actions;

export default userSlice.reducer;